import { connect } from "react-redux";
import { list_orders } from "../../redux/actions/orders";
import { get_items, get_total, get_item_total } from "../../redux/actions/cart";
import { useEffect } from "react";
import { Navigate } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";
import SideNav from "../../components/dashboard/Sidebar";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DashboardPayments = ({
  list_orders,
  get_items,
  get_total,
  get_item_total,
  orders,
  isAuthenticated,
  user,
}) => {
  useEffect(() => {
    get_items();
    get_total();
    get_item_total();
    list_orders();
  }, []);

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <SideNav user={user}>
      <main className="flex-1">
        <div className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
              <div className="bg-white">
                <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
                  <div className="mt-8">
                    <div className="space-y-12">
                      {orders.map((product) => (
                        <>
                          <h2 className="sr-only">Productos comprados</h2>
                          <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
                            Orden de Compra
                          </h1>

                          <div className="text-sm border-b border-gray-200 mt-2 pb-5 sm:flex sm:justify-between">
                            <dl className="flex">
                              <dt className="text-gray-500">
                                ID de Transacción: &nbsp;
                              </dt>
                              <dd className="font-medium text-gray-900">
                                {product.transaction_id}
                              </dd>
                              <dt>
                                <span className="sr-only">Fecha</span>
                                <span
                                  className="text-gray-400 mx-2"
                                  aria-hidden="true"
                                >
                                  &middot;
                                </span>
                              </dt>
                              <dd className="font-medium text-gray-900">
                                <time dateTime={product.date_issued}>
                                  {moment(product.date_issued).fromNow()}
                                </time>
                              </dd>
                            </dl>
                            <div className="mt-4 sm:mt-0">
                              <Link
                                to={`/dashboard/payment/${product.transaction_id}`}
                                className="font-medium text-indigo-600 hover:text-indigo-500"
                              >
                                Ver factura
                                <span aria-hidden="true"> &rarr;</span>
                              </Link>
                            </div>
                          </div>
                          <div
                            key={product.id}
                            className="grid grid-cols-1 text-sm sm:grid-rows-1 sm:grid-cols-12 sm:gap-x-6 md:gap-x-8 lg:gap-x-8"
                          >
                            <div className="mt-6 sm:col-span-7 sm:mt-0 md:row-end-1">
                              <h3 className="text-lg font-medium text-gray-900">
                                <Link to={`/product/${product.id}`}>
                                  {product.name}
                                </Link>
                              </h3>
                              <p className="font-medium text-gray-900 mt-1">
                                ID de Transacción: {product.transaction_id}
                              </p>
                              <p className="text-gray-500 mt-3">
                                {product.description}
                              </p>
                            </div>
                            <div className="sm:col-span-12 md:col-span-7">
                              <dl className="grid grid-cols-1 gap-y-8 border-b py-8 border-gray-200 sm:grid-cols-2 sm:gap-x-6 sm:py-6 md:py-10">
                                <div>
                                  <dt className="font-medium text-gray-900">
                                    Dirección de Entrega
                                  </dt>
                                  <dd className="mt-3 text-gray-500">
                                    <span className="block">
                                      {product.address_line_1}
                                    </span>
                                    {product.address_line_2 && (
                                      <span className="block">
                                        {product.address_line_2}
                                      </span>
                                    )}
                                  </dd>
                                </div>
                                <div>
                                  <dt className="font-medium text-gray-900">
                                    Envío
                                  </dt>
                                  <dd className="mt-3 text-gray-500 space-y-3">
                                    <p>$ {product.shipping_price}</p>
                                    <p>Total: $ {product.amount}</p>
                                  </dd>
                                </div>
                              </dl>
                              <p className="font-medium text-gray-900 mt-6 md:mt-10">
                                Estado: {product.status}
                              </p>
                              <div className="mt-6">
                                <div className="bg-gray-200 rounded-full overflow-hidden">
                                  <div
                                    className="h-2 bg-indigo-600 rounded-full"
                                    style={{
                                      width: `calc((${product.step} * 2 + 1) / 8 * 100%)`,
                                    }}
                                  />
                                </div>
                                <div className="hidden sm:grid grid-cols-4 font-medium text-gray-600 mt-6">
                                  <div className="text-indigo-600">
                                    Pedido realizado
                                  </div>
                                  <div
                                    className={classNames(
                                      product.step > 0 ? "text-indigo-600" : "",
                                      "text-center",
                                    )}
                                  >
                                    Procesando
                                  </div>
                                  <div
                                    className={classNames(
                                      product.step > 1 ? "text-indigo-600" : "",
                                      "text-center",
                                    )}
                                  >
                                    Enviado
                                  </div>
                                  <div
                                    className={classNames(
                                      product.step > 2 ? "text-indigo-600" : "",
                                      "text-right",
                                    )}
                                  >
                                    Entregado
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </SideNav>
  );
};

const mapStateToProps = (state) => ({
  orders: state.Orders.orders,
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
});

export default connect(mapStateToProps, {
  list_orders,
  get_items,
  get_total,
  get_item_total,
})(DashboardPayments);
